import { YANADOO_CDN_HOST } from 'common/config'

// 웹뷰 환경 감지
export const isWebView = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /yanadoo_aos/.test(userAgent) || /yanadoo_ios/.test(userAgent)
}

export const CACHE_PREFIX = 'yanadoo_lottie_cache_'
export const CACHE_META_KEY = 'yanadoo_lottie_cache_meta'
// 웹뷰 환경에서는 더 작은 캐시 사이즈 사용
export const MAX_CACHE_SIZE = isWebView() ? 20 : 50
// 웹뷰 환경에서는 더 짧은 캐시 유효기간 사용 (6시간)
export const CACHE_EXPIRY_TIME = isWebView() ? 6 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000

export const DEFAULT_LOTTIE_OPTIONS = {
  loop: true,
  play: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
    // 웹뷰에서의 성능 최적화
    progressiveLoad: true,
    hideOnTransparent: true
  }
}

export const API_ENDPOINTS = {
  LOTTIE: (fileName) => `${YANADOO_CDN_HOST}/lottie/${fileName}`
}
